
import React from "react";
import {
  Platform,
  UIManager,
} from "react-native";
import { useIsFocused } from "@react-navigation/native";

import Animated from "react-native-reanimated";

import { defaultNavigationProps } from "../Navigator/Navigator";
import RenderCatalog from "./Components/RenderCatalog/RenderCatalog";

if (
  Platform.OS === "android" &&
  UIManager.setLayoutAnimationEnabledExperimental
) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

/* ---------- MAIN COMPONENT ---------- */
type CatalogProps = defaultNavigationProps & {
  contentHeight?: number;
};

const Catalog: React.FC<CatalogProps> = ({ navigation, contentHeight }) => {
  const isFocused = useIsFocused();
  return (
    <Animated.View style={{ flex: 1 }}>
      <RenderCatalog
        navigation={navigation}
        contentHeight={contentHeight}
        isFocused={isFocused}
      />
    </Animated.View>
  );
};

export default React.memo(Catalog);